<script setup lang="ts">
import CustomButton from '@/components/CustomButton.vue';
import { useGlobalStore } from '@/stores/global';
import { detectApiConnectionStatus } from '@/utils/api';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const globalStore = useGlobalStore();
const { t: translate } = useI18n();

const loading = ref(false);

async function retryConnection() {
    loading.value = true;
    try {
        await detectApiConnectionStatus();
    } finally {
        loading.value = false;
    }
}
</script>
<template>
    <v-overlay v-model="globalStore.isConnectionError" persistent>
        <v-snackbar v-model="globalStore.isConnectionError" :timeout="-1" color="error" location="center" height="150" width="500">
            <p class="text-white text-center m-0 p-0">{{ translate('error.NetworkError') }}</p>
            <div class="d-flex justify-center">
                <CustomButton :loading="loading" text="Probeer opnieuw" color="primary" @click="retryConnection" class="mt-5"/>
            </div>
        </v-snackbar>
    </v-overlay>
</template>

<style scoped>
.v-snackbar__content p {
    font-size: 20px;
}
</style>
